export const visitorTypeOptions = [
    { value: 'bnb', label: 'BnB' },
    { value: 'indrive', label: 'inDrive' },
    { value: 'visitor', label: 'Visitor' },
    { value: 'guest', label: 'Guest' },
    { value: 'delivery', label: 'Delivery' },
    { value: 'contractor', label: 'Contractor' },
    { value: 'service', label: 'Service' },
    { value: 'meeting', label: 'Meeting' },
    { value: 'other', label: 'Other' },
];

const addVisitorModel = {
    formId: 'createAccountForm',
    formField: {
        isPermanentVisitor: {
            name: 'isPermanentVisitor',
            label: 'Add as a Permanent Visitor',
        },
        isMultiDay: {
            name: 'isMultiDay',
            label: 'Multi-day Invite',
        },
        firstName: {
            name: 'firstName',
            label: 'First Name',
            required: true,
            requiredErrorMsg: 'The visitors first name is required',
            invalidErrorMsg: 'Invalid first name'
        },
        lastName: {
            name: 'lastName',
            label: 'Last Name',
            required: true,
            requiredErrorMsg: 'The visitors last name is required',
            invalidErrorMsg: 'Invalid last name'
        },
        visitorEmail: {
            name: 'visitorEmail',
            label: 'Visitor Email',
            required: false,
            requiredErrorMsg: 'Provide either a visitor email or WhatsApp number',
            invalidErrorMsg: 'Invalid email address'
        },
        visitorWhatsApp: {
            name: 'visitorWhatsApp',
            label: 'Visitor WhatsApp Number',
            required: false,
            invalidErrorMsg: 'Invalid WhatsApp number'
        },
        visitorType: {
            name: 'visitorType',
            label: 'Visitor Type',
            required: true,
            requiredErrorMsg: 'Visitor type is required',
        },
        purpose: {
            name: 'purpose',
            label: 'Purpose of Visit',
            required: false,
            requiredErrorMsg: 'Purpose of visit is required when Visitor Type is Other',
        },
        visitDateTime: {
            name: 'visitDateTime',
            label: 'Visit Date & Time',
            required: false,
            requiredErrorMsg: 'Visit Date & Time is required',
            invalidErrorMsg: 'Invalid Visit Date & Time'
        },
        startDate: {
            name: 'startDate',
            label: 'Start Date',
            required: false,
            requiredErrorMsg: 'Start Date is required',
            invalidErrorMsg: 'Invalid Start Date'
        },
        endDate: {
            name: 'endDate',
            label: 'End Date',
            required: false,
            requiredErrorMsg: 'End Date is required',
            invalidErrorMsg: 'Invalid End Date'
        },
        idNumber: {
            name: 'idNumber',
            label: 'ID Number',
            required: true,
            requiredErrorMsg: 'ID Number is required',
            invalidErrorMsg: 'Invalid ID Number'
        },
        propertyId: {
            name: 'propertyId',
            label: 'Select Property',
            required: true,
            requiredErrorMsg: 'Property selection is required',
            invalidErrorMsg: 'Invalid property selection'
        },
        consent: {
            name: 'consent',
            label: 'I confirm the visitor has been informed their details are shared with WestProp for access control purposes',
            required: true,
            requiredErrorMsg: 'Please confirm visitor consent before submitting',
        },
    },
    initialValues: {
        isMultiDay: false,
        firstName: '',
        lastName: '',
        visitorEmail: '',
        visitorWhatsApp: '',
        visitorType: 'guest',
        purpose: '',
        visitDateTime: '',
        startDate: '',
        endDate: '',
        propertyId: '',
        consent: false,
    }
};

export type addVisitorModelType = {
    isMultiDay: boolean,
    firstName: string,
    lastName: string,
    visitorEmail: string,
    visitorWhatsApp: string,
    visitorType: string,
    purpose: string,
    visitDateTime: string,
    startDate: string,
    endDate: string,
    consent: boolean,
    propertyId: string,
}

export default addVisitorModel
